// Shared formatting helpers.

// formatPhone — strip non-digits; if exactly 10 digits, render "(214) 987-9874";
// otherwise return the raw value unchanged (handles already-formatted, extensions,
// intl, or empty input gracefully).
export function formatPhone(raw) {
  if (!raw) return raw;
  const d = String(raw).replace(/\D/g, '');
  if (d.length === 10) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  return raw;
}

// countyFromAssessor — derive a bare, title-cased county name from an assessor. Assessors are county-named
// ("DeKalb County Board of Tax Assessors", "Harris CAD", "Appling County"); strip the office/jurisdiction suffixes
// down to the county core, PRESERVING original casing so it matches properties.county's convention ("Dallas",
// "Davidson"). Returns null when nothing recognizable remains. NOT nameCore (that preserves "County" + lowercases).
//
// Accepts a string (free-text assessor) OR a linked-assessor row ({ county, name }) — prefers a populated `county`
// column, else parses `name`.
// NOTE: order matters — strip the "board of (tax) assessors" phrase BEFORE "tax assessors" so the longer match wins.
const COUNTY_STRIP = [
  /\bboard of (tax )?assessors\b/ig,   // "Board of Tax Assessors" / "Board of Assessors"
  /\btax assessors?\b/ig,
  /\btax commissioners?\b/ig,
  /\bappraisal district\b/ig,
  /\bcad\b/ig,
  /\bcounty\b/ig,
];
export function countyFromAssessor(input) {
  if (!input) return null;
  const raw = (typeof input === 'object')
    ? ((input.county && String(input.county).trim()) ? input.county : input.name)
    : input;
  if (!raw) return null;
  let s = String(raw);
  for (const re of COUNTY_STRIP) s = s.replace(re, ' ');
  s = s.replace(/[.,]/g, ' ').replace(/\s+/g, ' ').trim();
  return s || null;
}
